<template>
    <div class="NodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :id="node.id"
            :slug="node.slug"
            :type="node.type"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <div class="scroll-container fci-scrollbar">
            <ScenarioCard name="Portal">
                <table v-if="sourceNode" class="edit-table">
                    <tr>
                        <td>Name</td>
                        <td>{{ sourceNode.name }}</td>
                    </tr>
                    <tr>
                        <td>Id</td>
                        <td>{{ sourceNode.id }}</td>
                    </tr>
                </table>
                <div class="action-portal mt-12">
                    <div @click="selectNode" class="btn-custom-2 mr-8" v-if="isEdit">{{ $f.tc('changeSource') }}</div>
                    <div @click="goToSourceNode" class="btn-custom-2">{{ $f.tc('goToSourceNode') }}</div>
                </div>
            </ScenarioCard>
        </div>
        <ScenarioNodeSelector ref="ScenarioNodeSelector"></ScenarioNodeSelector>
    </div>
</template>

<script>
import NodeEditor from "@/views/Scenario/NodeEditor/NodeEditor";
import NodeHeaderEditor from "@/views/Scenario/NodeEditor/common/NodeHeaderEditor";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard";
import ScenarioNodeSelector from "@/views/Scenario/ScenarioNodeSelector";
import NodeSaveStatus from "@/views/Scenario/NodeEditor/NodeSaveStatus";
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";

const {NodeType} = ScenarioService

export default {
    name: "PortalNodeEditor",
    extends: NodeEditor,
    components: {NodeHeaderEditor, ScenarioCard, ScenarioNodeSelector, NodeSaveStatus},
    data() {
        return {
            name: '',
            sourceNode: null
        }
    },
    computed: {
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        }
    },
    methods: {
        selectNode() {
            this.$refs.ScenarioNodeSelector.open(
                this.$store.state.scenario.treeData.nodeList.filter(
                    node => node.type === NodeType.PROCESS || node.type === NodeType.SUPPORTER
                )
            ).then(
                node => {
                    this.sourceNode = node
                    this.node.config = {id: this.sourceNode.id}
                    this.saveNode()
                }
            )
        },
        validateNodeData() {
            if (!this.node.name) {
                return 'Name not valid'
            }
            if (!this.sourceNode) {
                return 'You need to pick a source node'
            }
            return true
        },
        goToSourceNode() {
            this.$emit('changeEditNode', this.sourceNode)
        }
    },
    watch: {
        node: {
            immediate: true,
            deep: true,
            handler: function () {
                let id = this.node.config.id
                if (id) {
                    let nodeList = this.$store.state.scenario.treeData.nodeList
                    this.sourceNode = nodeList.find(node => node.id === id) || null
                } else {
                    this.sourceNode = null
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
@import "NodeEditor.scss";

.edit-table tr td:first-child {
    font-weight: bold;
}

.action-portal {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.btn-custom, .btn-custom-2 {
    line-height: 32px !important;
}
</style>
